var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 96,
    viewBox: "0 0 68 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.1217 80.9991C44.1217 80.9991 42.5571 68.1665 42.3336 64.888C42.11 61.6095 42.2593 58.9273 41.7372 58.0332C41.216 57.1391 37.4162 49.7631 37.1176 45.5163C36.8199 41.2695 36 38.438 36 36.6499C36 34.8617 37.1176 31.0619 37.3411 29.6466C37.5646 28.2313 37.8623 25.5491 39.1292 25.2505C40.3961 24.9528 41.8856 25.027 42.7055 25.2505C43.5253 25.474 44.9407 26.4423 44.9407 26.4423",
    stroke: "#EBA713",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4702 28.1572C40.4702 28.1572 42.7054 31.4724 45.5735 31.1747",
    stroke: "#EBA713",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6885 32.9252C39.6885 32.9252 41.1896 33.0629 43.1959 30.6471",
    stroke: "#EBA713",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9042 25.0548C41.9042 25.0548 41.8487 20.3896 41.9042 18.2107C41.9596 16.0319 41.9104 14.4664 41.8791 11.5052C41.8479 8.5441 41.9086 6.36437 43.5832 6.25261C45.2569 6.14085 46.2627 7.03491 46.2073 13.0135C46.1519 18.9921 47.2695 21.0047 47.3249 24.0776",
    stroke: "#EBA713",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0015 26.1456L49.3931 20.3342C49.3931 20.3342 49.5048 18.3225 49.9519 16.1991C50.3989 14.0757 50.7905 11.617 50.7905 10.0524C50.7905 8.48779 51.3493 4.91153 51.3493 3.23516C51.3493 1.55879 52.4114 1 53.3609 1C54.3104 1 55.875 1.50246 55.875 5.35857C55.875 9.21467 55.8196 14.2992 55.3726 19.1611C54.9255 24.0231 54.5903 23.129 54.4785 26.1465",
    stroke: "#EBA713",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1367 26.8716C53.1367 26.8716 56.0424 26.59 56.6575 25.0549C57.2727 23.5188 57.8306 20.7249 58.7246 18.7132C59.6187 16.7016 60.2892 14.5782 60.9044 12.8464C61.5195 11.1146 62.469 4.63173 64.9831 5.3586C67.4972 6.08548 66.4359 9.54998 65.5419 13.5733C64.6478 17.5966 64.3689 19.8317 62.7479 24.4138C61.127 28.9959 61.2387 28.3325 61.0715 30.6481C60.9044 32.9638 60.7926 36.1484 60.848 38.1601C60.9035 40.1717 60.4564 42.1279 60.3456 45.9277C60.2347 49.7275 59.7304 51.858 59.1162 53.0284C58.5011 54.1978 58.4457 54.4776 58.9481 61.1268C59.4506 67.776 59.7304 69.3969 60.0657 71.6875C60.401 73.9781 62.2455 81.0001 62.2455 81.0001",
    stroke: "#EBA713",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1247 38.1038C51.1247 38.1038 49.1685 40.8414 49.5047 45.6479",
    stroke: "#EBA713",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4269 43.1507C55.4269 43.1507 52.6375 40.8503 51.1247 37.8239C49.8954 35.3652 48.219 35.7568 46.1519 32.236C46.1519 32.236 43.9892 27.9507 45.5743 25.0548C47.1595 22.1589 49.6718 27.4304 50.5659 28.6597C51.46 29.889 53.5834 32.1805 54.5338 33.3535C55.4842 34.5265 56.4524 35.4841 57.4395 36.2959C58.7028 37.3339 60.6912 38.4166 60.7699 40.1878",
    stroke: "#EBA713",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6875 74.7969L28.5156 54.5625H34.3555L28.0469 83H22.1484L17.5195 63.9766L12.8906 83H6.99219L0.683594 54.5625H6.52344L10.3711 74.7578L15.0586 54.5625H20.0195L24.6875 74.7969Z",
    fill: "url(#paint0_diamond)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.197 71.8929) rotate(89.2299) scale(45.0934 18.0412)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD458",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9BF2E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhand);
export default __webpack_public_path__ + "static/media/Whand.64b46f07d80f7b68d54c33e4a5bc654d.svg";
export { ForwardRef as ReactComponent };